// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox {
  display: block;
  position: relative;
  padding-left: 25px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 15px;
  -webkit-user-select: none;
  user-select: none;
}

.checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 26px;
  border: 1.5px solid rgb(159, 161, 164);
}

.checkbox input:checked ~ .checkmark {
  background-color: rgb(237, 28, 36);
  border: 1px solid rgb(237, 28, 36);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox input:checked ~ .checkmark:after {
  display: block;
}

.checkbox .checkmark:after {
  left: 9px;
  top: 4px;
  width: 7px;
  height: 13px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

.checkbox a {
  color: rgb(237, 28, 36);
}

.checkbox a:hover {
  color: rgb(0, 57, 117);
}`, "",{"version":3,"sources":["webpack://./src/app/agent/agent-transfer-to-applicant/agent-transfer-to-applicant.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;AACF;;AACA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;AAEF;;AAAA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,sCAAA;AAGF;;AAEA;EACE,kCAAA;EACA,kCAAA;AACF;;AACA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;AAEF;;AAAA;EACE,cAAA;AAGF;;AADA;EACE,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EAGA,wBAAA;AAIF;;AAFA;EACE,uBAAA;AAKF;;AAHA;EACE,sBAAA;AAMF","sourcesContent":[".checkbox {\r\n  display: block;\r\n  position: relative;\r\n  padding-left: 25px;\r\n  margin-bottom: 12px;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n.checkbox input {\r\n  position: absolute;\r\n  opacity: 0;\r\n  cursor: pointer;\r\n  height: 0;\r\n  width: 0;\r\n}\r\n.checkmark {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  height: 25px;\r\n  width: 26px;\r\n  border: 1.5px solid rgb(159, 161, 164);\r\n}\r\n// .checkbox:hover input ~ .checkmark {\r\n\r\n// }\r\n.checkbox input:checked ~ .checkmark {\r\n  background-color: rgb(237, 28, 36);\r\n  border: 1px solid rgb(237, 28, 36);\r\n}\r\n.checkmark:after {\r\n  content: '';\r\n  position: absolute;\r\n  display: none;\r\n}\r\n.checkbox input:checked ~ .checkmark:after {\r\n  display: block;\r\n}\r\n.checkbox .checkmark:after {\r\n  left: 9px;\r\n  top: 4px;\r\n  width: 7px;\r\n  height: 13px;\r\n  border: solid white;\r\n  border-width: 0 3px 3px 0;\r\n  -webkit-transform: rotate(45deg);\r\n  -ms-transform: rotate(45deg);\r\n  transform: rotate(45deg);\r\n}\r\n.checkbox a {\r\n  color: rgb(237, 28, 36);\r\n}\r\n.checkbox a:hover {\r\n  color: rgb(0, 57, 117);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
